import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'source';

const SourceService = {
  getList() {
    return Http.get(`/${RESOURCE_NAME}/list`);
  },
  getListByStudent() {
    return Http.get(`/${RESOURCE_NAME}/list`);
  },
};

export default SourceService;
